import React, { useLayoutEffect } from 'react'
import Children from 'react-children-utilities'
import * as uuid from 'uuid'
import { pgnView, pgnEdit } from '@mliebelt/pgn-viewer'

//https://mliebelt.github.io/PgnViewerJS/config/config.html
export default function PGNViewer({ pgn, size}) {
    var startPos = "";
    const gameDecription = pgn.join('\n'); //Children.onlyText(props.children)
    //const startPos = pgn.
    //'[FEN "rbkrbqnn/pppppppp/8/8/8/8/PPPPPPPP/RBKRBQNN w DAda - 0 1"]'
    

    for (var i = 0; i < pgn.length; i++) {
        if (pgn[i].includes('[FEN ')) {
            startPos = pgn[i].replace('[FEN "', '');
            startPos = startPos.replace('"]', '');
        };
        
    }


    const id = 'board-' + uuid.v4();

    useLayoutEffect(() => {
        pgnEdit(id,
            { 
                pgn: gameDecription,
                showCoords: false,
                locale: 'en',
                startPlay: 0,
                showResult: true,
                boardSize: size*80/100,
                showFen: false,
                pieceStyle: 'merida',
                timerTime: '1000',
                theme: 'brown',
                headers: true,
                layout: 'top',
                notationLayout: 'inline',
                position: startPos,
                colorMarker: 'circle',
                showCoords: 'true',
                coordsInner: false,
                showFen: false,
                colorMarker: 'cm-small'
                //viewOnly: false, // Allow interaction
                //mode: 'pgnEdit' // Enable PGN editing mode
            }
        )
    })

    return (
        <div id={id}></div>
    )
}